module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-InfomationModel-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-AddInfomationModel-Button",
      "type": "warning",
      "id": "btn-im-form"
    },
    on: {
      "click": _vm.addInformationModal
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelButtonAddInfomationModelText')) + "\n    ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "im-table",
    attrs: {
      "element-loading-text": _vm.$t('informationModelTableLoadingText'),
      "data": _vm.informationModels,
      "default-sort": _vm.defaultSort,
      "data-qa": "Content-InformationModel-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "im-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColFamilyNameLabel'),
      "prop": "index",
      "sortable": "",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColFileNameLabel'),
      "prop": "name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColModelImageLabel'),
      "prop": "informationModel",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.hasNoImages(scope.row.informationModel)) ? _c('el-button', {
          attrs: {
            "data-qa": ("Content-InformationModel-UploadImages-" + (scope.row.index)),
            "size": "medium"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showSetImagePopup(scope.row.informationModel, false)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t('informationModelButtonUploadImagesText')) + "\n        ")]) : _c('div', {
          staticClass: "edit-image"
        }, [(_vm.getImageSrc(scope.row.informationModel)) ? _c('img', {
          attrs: {
            "src": _vm.getImageSrc(scope.row.informationModel),
            "height": "34"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "data-qa": ("Content-InformationModel-EditImages-" + (scope.row.index)),
            "size": "medium"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showSetImagePopup(scope.row.informationModel, true)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('informationModelButtonEditImagesText')) + "\n          ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColLastModifiedLabel'),
      "prop": "timestamp",
      "sortable": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.formatedDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColActionLabel'),
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('informationModelTooltipDownloadText'),
            "placement": "top-start"
          }
        }, [_c('a', {
          staticClass: "el-button el-button--mini el-button--text",
          attrs: {
            "data-qa": ("Content-DownloadInformationModel-Button-" + (scope.row.index)),
            "download": scope.row.name,
            "href": scope.row.downloadLink,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-download fa-2 operation-icons"
        })])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('informationModelTooltipDeleteText'),
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteInformationModel-Button-' + scope.row.index,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.removeInformationModel(scope.row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('information-model-delete'), _vm._v(" "), _c('information-model-images-upload'), _vm._v(" "), _c('information-model-upload')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d7e16a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformationModel/InformationModel.vue
// module id = 955
// module chunks = 3